export type RequiredFields<T, K extends keyof T> = T & Required<Pick<T, K>>;
export type OptionalFields<T, K extends keyof T> = Omit<T, K> & { [P in K]?: T[P] };

export type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

export function isString(value: unknown): value is string {
  return typeof value === 'string';
}

export type ClassProperties<C> = {
  [Key in keyof C as C[Key] extends Function ? never : Key]: C[Key];
};

export type WithStringId<T> = Omit<T, '_id'> & { _id: string };
export type NonUndefined<T> = T extends undefined ? never : T;

// Define a standard return type for operations
type TryCatchResult<T, E = Error> = { data: T; error: null } | { data: null; error: E };

// Utility to wrap operations
export async function tryCatch<T, E = Error>(promise: Promise<T>): Promise<TryCatchResult<T, E>> {
  try {
    const data = await promise;
    return { data, error: null };
  } catch (error) {
    return { data: null, error: error as E };
  }
}
